import { apiReturnResults } from '../../../../ApiFactory';
import { Request } from '../../../../common';
import {
    type ApiResult,
    type BaseParams,
    type ChainCollectionMetadata,
    type ChainContractMetadata,
    type ChainTokenCount,
} from '../../../../common/structs';
import { links } from '../../../../links';

export type MetadataCallType = 'contract' | 'collection' | 'tokenCount';
export const getCollectionMetadata = (
    params: BaseParams & { type: MetadataCallType },
): Promise<ApiResult<ChainContractMetadata | ChainCollectionMetadata | ChainTokenCount>> => {
    const target = links.daas().v2.metadata[params.type];
    return Request.getRequest<ChainContractMetadata | ChainCollectionMetadata | ChainTokenCount>({
        ...params,
        target,
        apiSettingsType: 'daasV2',
    });
};
export const callGetCollectionMetadata = (params: BaseParams & { type: MetadataCallType }) =>
    apiReturnResults<ChainCollectionMetadata>(getCollectionMetadata, params, true);

export const callGetCollectionTokenCount = (params: BaseParams & { type: MetadataCallType }) =>
    apiReturnResults<ChainTokenCount>(getCollectionMetadata, params, true);
